import Map from '../MapClasses/Map';
import MapPopup from '../map-pop-up/MapPopUp';

export default new class DataSortCatalog {
    constructor() {
        this.wrapper = '.data-sorter';
        this.btnClass = '.data-sorter__btn';
        this.listBtn = '._list-btn';
        this.mapBtn = '._map-btn';
        this.filterBtn = '._filter-btn';
        this.btnActive = '.data-sorter__btn_active';
        this.dropdownSort = '.js-dropdownSort';
        this.$btnActive = $('.data-sorter__btn_active');
        this.dataSorterDropdown = '.data-sorter__dropdown';
        this.dataSorterDropdownDisabled = '.data-sorter__dropdown_disabled';

        this.innerWrapperCatalogContent = '._product-list-wrapper';
        this.innerWrapperCatalogMap = '.inner-wrapper_catalog-map';
        this.wrapperHideClass = '.inner-wrapper_hide';

        if(this.$btnActive.length > 0) {
            this.switching = this.$btnActive.hasClass(this.listBtn.slice(1)) ?
                                this.listBtn : this.$btnActive.hasClass(this.mapBtn.slice(1)) ? this.mapBtn : null;

            // this.changeBtnClasses(this.switching);
            this.changeContent(this.switching);
        }
    }

    setHandlers() {
        $(document).on('click', `${this.listBtn}, ${this.mapBtn}`, (e) => {
            e.stopPropagation();
            e.preventDefault();

            let clickTarget = $(e.target),
                $btnGroup = $('.data-sorter__btn-group');


            if(clickTarget.hasClass(this.listBtn.slice(1))) {
                this.switching = this.listBtn;
                $btnGroup.removeClass('_map-view').addClass('_list-view');
            } else if(clickTarget.hasClass(this.mapBtn.slice(1))) {
                this.switching = this.mapBtn;

                $btnGroup.removeClass('_list-view').addClass('_map-view');
            }

            this.changeBtnClasses(this.switching);
            this.changeContent(this.switching);
        });
        
        $(document).on('click', `${this.filterBtn}`, () => {
            let $body = $('body'),
                $html = $('html');

            $('.filter').fadeIn(500, function () {
                $html.attr('data-scroll', $html.scrollTop());

                $body.css({'overflow':'hidden'});
                $html.css({'position':'fixed'});
            });
        });
    }

    changeBtnClasses(btnClassName) {
        let wrapper = $(this.wrapper);
        wrapper.find(btnClassName).addClass(this.btnActive.slice(1)).siblings(this.btnClass).removeClass(this.btnActive.slice(1));
    }

    changeContent(btnClassName) {
        if(!this.switching) return;

        let wrapper = $(this.wrapper),
            dataSorterDropdown = wrapper.find(this.dataSorterDropdown),
            catalogContent = $(this.innerWrapperCatalogContent),
            catalogMap = $(this.innerWrapperCatalogMap);

        if(btnClassName == this.listBtn) {
            Map.deleteMap();
            catalogContent.removeClass(this.wrapperHideClass.slice(1));
            catalogMap.addClass(this.wrapperHideClass.slice(1)).html('');


            dataSorterDropdown.removeClass(this.dataSorterDropdownDisabled.slice(1));
            $(this.dropdownSort).removeClass('_hide sorter-dropdown_disabled');

        } else if(btnClassName == this.mapBtn) {

            catalogMap.removeClass(this.wrapperHideClass.slice(1)).append(require('../map-for-catalog/map-for-catalog.pug')());
            catalogContent.addClass(this.wrapperHideClass.slice(1));

            dataSorterDropdown.addClass(this.dataSorterDropdownDisabled.slice(1));
            $(this.dropdownSort).addClass('_hide sorter-dropdown_disabled');


            $.getScript(MapPopup.yandexScriptSrc, () => {
                Map.mapInit({
                    noScroll: true,
                    balloonOpenResolutionFlag: true,
                    ajaxData: false
                });
            });
        }

    }
};


// WEBPACK FOOTER //
// ./src/common/modules/data-sorter/DataSortCatalog.js